import React, { useContext, useLayoutEffect, useRef, useState } from 'react';
import { Context } from '../../../context/global-data-provider';
import PostSmItem from './post-sm-item';
import PostSmScrollTop from './post-sm-scroll-top';
import PostSmScrollBottom from './post-sm-scroll-bottom';

import './post-sm-style.css';

export const VideoControl = React.createContext(null);

function PostSm() {
  const { post } = useContext(Context);

  const provider = {
    control: useRef(null),
    video: useRef(null),
    setControl: (c) => {
      provider.control.current = c;
    },
    setVideo: (v) => {
      provider.video.current = v;
    },
  };

  const manager = {};
  [manager.topLoadStatus, manager.setTopLoadStatus] = useState('initialing');
  [manager.bottomLoadStatus, manager.setBottomLoadStatus] = useState('initialing');

  const anchorRef = useRef(null);
  const anchorHold = useRef({
    viewportTop: null,
    userScrolled: false,
  });
  const pinRef = useRef(() => {});

  pinRef.current = () => {
    const hold = anchorHold.current;
    if (hold.userScrolled) {
      return;
    }

    const anchor = anchorRef.current;
    if (!anchor || hold.viewportTop == null) {
      return;
    }

    const delta = anchor.getBoundingClientRect().top - hold.viewportTop;
    if (Math.abs(delta) < 1) {
      return;
    }

    window.scrollBy(0, delta);
    hold.viewportTop = anchor.getBoundingClientRect().top;
  };

  useLayoutEffect(() => {
    const hold = anchorHold.current;
    hold.userScrolled = false;
    hold.viewportTop = null;

    const markUserScroll = () => {
      hold.userScrolled = true;
    };

    window.addEventListener('wheel', markUserScroll, { passive: true });
    window.addEventListener('touchmove', markUserScroll, { passive: true });

    window.scrollTo(0, 0);
    if (anchorRef.current) {
      hold.viewportTop = anchorRef.current.getBoundingClientRect().top;
    }

    return () => {
      window.removeEventListener('wheel', markUserScroll);
      window.removeEventListener('touchmove', markUserScroll);
    };
  }, [post.data.id]);

  return (
    <VideoControl.Provider value={provider}>
      <div className="sm">
        {(post.data.previousHasMore === 0 || manager.bottomLoadStatus === 'loaded') && (
          <PostSmScrollTop post={post.data} manager={manager} pinRef={pinRef} />
        )}

        <div id="post-sm-current" ref={anchorRef}>
          <PostSmItem data={post.data} />
        </div>

        <PostSmScrollBottom post={post.data} manager={manager} />
      </div>
    </VideoControl.Provider>
  );
}

export default PostSm;
